module.exports = __webpack_public_path__ + "img/landscape_3-lazy.9d534e0f.jpg";